import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e3ddbbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "myModal",
  ref: "refModal",
  class: "modal"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-filter-header" }
const _hoisted_4 = { class: "d-flex align-items-baseline justify-content-between w-100 filterText" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h5", null, "Filtrar informações")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-header" }, [
  /*#__PURE__*/_createElementVNode("h6", null, " Selecione os filtros para visualizar as informações da forma que você deseja. ")
], -1))
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h5", null, "Filtros Ativos")
], -1))
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = { class: "row tag-row" }
const _hoisted_11 = { class: "name" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_13 = { class: "container-slot" }
const _hoisted_14 = { class: "modal-footer" }
const _hoisted_15 = { class: "d-flex justify-content-between w-100" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Cancelar", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Aplicar", -1))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DassIcon = _resolveComponent("DassIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", null, [
            _createElementVNode("span", {
              class: "close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, [
              _createVNode(_component_DassIcon, {
                token: "icon-content-clear",
                size: "25"
              })
            ])
          ])
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterTag, (filterActive, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "container",
                key: index
              }, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(filterActive), 1)
              ]))
            }), 128))
          ])
        ]),
        _hoisted_12
      ]),
      _createElementVNode("div", _hoisted_13, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            class: "mt-2 cancel",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
          }, _hoisted_17),
          _createElementVNode("button", {
            class: "mt-2 save",
            disabled: !_ctx.hasModification,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emit('save-changes')))
          }, _hoisted_20, 8, _hoisted_18)
        ])
      ])
    ])
  ], 512))
}